import axios from "axios";
import { URL_BASE } from "./0_url_base";

//const URL = 'http://localhost:3001/filiado/ivenda';
//const URL = 'https://conexaodetranpr.sindilocpr.com.br/api/filiado/ivenda';
const URL = URL_BASE + '/filiado/ivenda';

const iVendaAPI = axios.create({
    baseURL: URL,
    headers: {
        Accept: 'application/json',
        Content: 'application/json'
    }
})

iVendaAPI.interceptors.request.use(function (config) {
    const Token = sessionStorage.getItem('token');
    if((Token) && (config.headers)){
        config.headers.Authorization = `Bearer ${Token}`
    }
    return config;
}, function (error) {
    console.log("Erro na API de Inteção de Venda");
    return Promise.reject(error);
});


iVendaAPI.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return Promise.reject(error);
});


export {
    iVendaAPI
};